import Vue from "vue";
import Vuex from 'vuex';
import auth from "./modules/auth"
import common from "./modules/common"
import onboarding from "./modules/onboarding"
import payment from "./modules/payment"
import notifications from "./modules/notifications"
import insights from "./modules/insights";
import kpis from "./modules/kpis"
import whiteLabel from "./modules/white-label"

Vue.use(Vuex);
export default new Vuex.Store({
  modules:{
    auth,
    common,
    insights,
    kpis,
    onboarding,
    payment,
    notifications,
    whiteLabel
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js